import { toolForAction } from "../../../shared/tools.ts";
import type { RepresentativeActionResult } from "../../../shared/representative.ts";

/**
 * The person's draft wins over the employee: while a surface is being edited by the human, a tool
 * result keeps its outcome (the action already ran on the server) but loses its view switch, and a
 * mutating action on that same tool is deferred with an `ask_user` result. Pure, so it is testable.
 */
export type EditingSurface = "notes" | "tasks" | "calendar" | null;
const MUTATING = /_(update|delete|complete)(_note)?$/;

export function guardSurfaceResult(result: RepresentativeActionResult, editing: EditingSurface): RepresentativeActionResult | undefined {
  if (!editing || !result.success || !result.navigation || result.navigation.surface === editing) return undefined;
  return {
    ...result,
    navigation: undefined,
    instructionToRealtime: `${result.instructionToRealtime} The view was not switched because the user is editing ${editing}: say the result is saved and will show once they save or cancel.`.trim(),
  };
}

export function guardTool(name: string, editing: EditingSurface): RepresentativeActionResult | undefined {
  const tool = toolForAction(name);
  if (!editing || !tool || tool.id !== editing || !MUTATING.test(name)) return undefined;
  return {
    success: false,
    answerMode: "ask_user",
    facts: [],
    instructionToRealtime: `The user is editing ${editing}. Wait until they save or cancel before changing it.`,
  };
}
